import { render, staticRenderFns } from "./orderNumber.vue?vue&type=template&id=772e0dfa&scoped=true&"
import script from "./orderNumber.vue?vue&type=script&lang=js&"
export * from "./orderNumber.vue?vue&type=script&lang=js&"
import style0 from "./orderNumber.vue?vue&type=style&index=0&id=772e0dfa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e0dfa",
  null
  
)

export default component.exports